import { defineComponent } from "../../../common/runtime/defineComponent.svelte";
import CheckboxV2 from "./CheckboxV2.svelte";

defineComponent({
  tag: "oc-checkbox-v2",
  extendOptions: { useOcAutoAriaLabel: true, visibilityInit: true },
  props: {
    labelPlacement: { attribute: "label-placement" },
    widthBehavior: { attribute: "width-behavior" },
    size: {},
  },
  component: () => CheckboxV2,
  styles: () => import("./CheckboxV2.global.scss?inline"),
});
